export const TRIAL_PAGES_V3C = 'v3c';
